import { DetailPageProductSkuOption } from '@rcm/cart-core/src';
import React, { useCallback, useEffect, useState } from 'react';
import './ProductDetailPageTopBlock.scss';
import { SkuButton } from './SkuButton';
import { QueryStatus } from '@reduxjs/toolkit/query'
import { getCheckoutOrderManager } from 'cart-ui/src';
import { GtagCartUpdateMethod } from 'google-analytics/src';
import LoadingSpinner from 'loading-spinner/LoadingSpinner';
import { ThumbImage } from './ThumbImage';
import { ProductImage } from '@rcm/cart-core/src/types/ProductImage';
import { BlockComponentProps } from 'client-react-block-renderer/src';

interface Props extends BlockComponentProps<Data, Config> { }

interface Config {
    topBodyHtml: string
}

interface Data {
    // showPrice: boolean;
    // showBvPv: boolean;
}

/**
 * @TODO render important content server side too for SEO
 * @TODO show BV/PV?
 * @TODO translations
 * @TODO improve mobile view
 * @TODO quantity selectors
 */
export const ProductDetailPageTopBlock = ({ config, data }: Props) => {
    const product = window.pageProductV2;
    const [addToCartOperationStatus, setAddToCartOperationStatus] = useState<QueryStatus>(QueryStatus.uninitialized);
    const skus = product.activeSkuOptionsAsSortedArray;
    const [selectedSku, setSelectedSku] = useState<DetailPageProductSkuOption>(null);
    const [selectedImage, setSelectedImage] = useState<ProductImage>(null);

    useEffect(() => {
        if (selectedSku === null && skus.length !== 0) {
            setSelectedSku(skus.find(sku => sku.isDefault) || skus[0] || null);
        }
    }, [selectedSku])

    useEffect(() => {
        if (!selectedSku) {
            return;
        }
        const selectedSkuContainsSelectedImage = !!selectedSku.images.find(image => image === selectedImage);
        if (!selectedImage || !selectedSkuContainsSelectedImage) {
            setSelectedImage(selectedSku.images[0] || null); //@TODO respect sort order, or ensure server does this?
        }
    }, [selectedSku, selectedImage])

    const handleSkuButtonClick = useCallback((sku: DetailPageProductSkuOption) => {
        setSelectedSku(sku);
    }, [])

    const handleAddToCardButtonClick = useCallback(() => {
        (async () => {
            setAddToCartOperationStatus(QueryStatus.pending);
            const orderMgr = await getCheckoutOrderManager();
            try {
                await orderMgr.addItems([{ skuNumber: selectedSku.skuNumber, qty: 1 }], { //@TODO "qty: 1"
                    cart_update_method: GtagCartUpdateMethod.PRODUCT_DETAILS_PAGE,
                });
                orderMgr.redirectToCart();
            } catch (error) {
                // tslint:disable-next-line:no-console
                console.error(error);
                setAddToCartOperationStatus(QueryStatus.rejected);
            }
        })();
    }, [selectedSku])

    const handleThumbImageHover = useCallback((image) => {
        setSelectedImage(image);
    }, [])

    console.log('skus', skus, 'selectedSku', selectedSku);
    if (!selectedSku) {
        return <></>;
    }
    return <div className="ProductDetailPageTopBlock">
        <div className="ProductDetailPageTopBlock-grid">
            <div className="ProductDetailPageTopBlock-grid-product-thumbs">
                {selectedSku.images.length > 1 && <>
                    {selectedSku.images.map(image => <ThumbImage key={image.imageId} image={image} isSelected={image === selectedImage} onHover={handleThumbImageHover} />)}
                    {/* @TODO remove these test images */}
                    <img className="ProductDetailPageTopBlock-side-thumb" src="https://m.media-amazon.com/images/I/91vEakl90aL._AC_SX679_.jpg" />
                    <img className="ProductDetailPageTopBlock-side-thumb" src="https://m.media-amazon.com/images/I/817G9-AuAgL._AC_SX679_.jpg" />
                    <img className="ProductDetailPageTopBlock-side-thumb" src="https://m.media-amazon.com/images/I/31WtvkG0dhL._AC_.jpg" />
                </>}
            </div>
            <div className="ProductDetailPageTopBlock-grid-product-image">
                {selectedImage &&
                    <img className="ProductDetailPageTopBlock-main-image" src={selectedImage.imageSrc} />
                }
            </div>
            <div className="ProductDetailPageTopBlock-grid-product-name">
                <h1>{selectedSku.name}</h1>
            </div>
            <div className="ProductDetailPageTopBlock-grid-product-options">
                <div>
                    <span className="ProductDetailPageTopBlock-minor-label">Price:</span>
                    &nbsp;
                    <span className="ProductDetailPageTopBlock-price">{selectedSku.formattedRetailPrice}</span>
                </div>
                {skus.length > 1 &&
                    <>
                        <div>
                            <span className="ProductDetailPageTopBlock-minor-label">Option:</span>
                            &nbsp;
                            <strong>{selectedSku.optionDescription.trim()}</strong>
                        </div>

                        <div className="ProductDetailPageTopBlock-option-selector-button-wrap">
                            {skus.map(sku => <SkuButton key={sku.skuNumber} sku={sku} isSelected={sku === selectedSku} onClick={handleSkuButtonClick} />)}
                        </div>
                    </>
                }
            </div>
            <div className="ProductDetailPageTopBlock-grid-product-copy">
                <div>
                    <hr />
                    <div dangerouslySetInnerHTML={{ __html: config.topBodyHtml }} />
                </div>
            </div>
            <div className="ProductDetailPageTopBlock-grid-buy-box">
                <div className="panel panel-default ProductDetailPageTopBlock-add-to-cart-panel">
                    <div className="panel-body">
                        <div><strong>One-time purchase:</strong></div>
                        <div className="ProductDetailPageTopBlock-price">{selectedSku.formattedRetailPrice}</div>
                        {/* <div className="ProductDetailPageTopBlock-in-stock">In Stock.</div> */}
                        {/* @TODO handle QueryStatus.rejected */}
                        {addToCartOperationStatus === QueryStatus.pending
                            ? <LoadingSpinner />
                            : <>
                                <div>
                                    <select><option>Qty: 1</option></select>
                                </div>
                                <button className="btn btn-primary" onClick={handleAddToCardButtonClick}>Add to Cart</button>
                            </>
                        }
                        <hr />

                        <div><strong>Subscribe &amp; Save:</strong></div>
                        {/* @TODO don't hard code price! */}
                        <div className="ProductDetailPageTopBlock-price">$23.20</div>
                        <div>Customers save 20% on repeat deliveries.</div>
                        <ul className="ProductDetailPageTopBlock-subscribe-and-save-ul">
                            <li>No fees</li>
                            <li>Cancel anytime</li>
                        </ul>
                        <div><a href="#">Learn more</a></div>
                        {/* <div className="ProductDetailPageTopBlock-in-stock">In Stock.</div> */}
                        <div>
                            <select><option>Qty: 1</option></select>
                        </div>
                        <button className="btn btn-primary">Add to Auto Ship</button>

                        {/* <hr />
                        <div className="ProductDetailPageTopBlock-panel-bottom-note">Ships from and sold by Reliv USA</div> */}
                    </div>
                </div>
            </div>
        </div>
        <div className="clearfix">
        </div>
        <hr />
    </div>
};